<template>
  <spinner-container :loading="localLoading">
    <back-btn />
    <v-container>
      <v-row no-gutters justify="center">
        <v-col lg="10">
          <v-card class="card--shadow">
            <v-card-text>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="`/app-user-report/${data.id}`"
                    dark
                    depressed
                    color="teal accent-4"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    class="mr-5"
                  >
                    Application User Visit report
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span> Application User Visit report</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="`/no-app-user-report/${data.id}`"
                    dark
                    depressed
                    color="teal accent-4"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    class="mr-5"
                  >
                    No Application User Visit report
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span>No Application User Visit report</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="`/dots-activity/${data.id}`"
                    dark
                    depressed
                    color="teal accent-4"
                    outlined
                    class="mr-5"
                    v-bind="attrs"
                    v-on="on"
                  >
                    DOT Activity
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span>No Application User basic report</span>
              </v-tooltip>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="10">
          <edit-form :data="data" @emitData="submitData" />
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import EditForm from "@/components/dots/EditForm";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    EditForm,
    SpinnerContainer,
    BackBtn,
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store
      .dispatch("DotsPatient/getEach", {
        column: "id",
        value: this.$route.params.id,
      })
      .then((isPass) => {
        if (isPass) this.$store.dispatch("Loading/changeLocalLoading");
      });
  },
  computed: {
    ...mapState("DotsPatient", ["data"]),
    ...mapState("Loading", ["localLoading"]),
  },
  methods: {
    submitData(data) {
      console.log(data);
      this.$store.dispatch("DotsPatient/update", {
        id: this.$route.params.id,
        phone: data.phone,
        body_weight: data.body_weight,
        dots_drugs:data.dots_drugs
      });
    },
  },
};
</script>

<style></style>
